import {
    List,
    EditButton,
    Datagrid,
    TextField,
    useRecordContext,
    ShowButton,
    FieldProps,
    Filter,
    TextInput,
    SelectInput,
    Link,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { SoftDeleteWithDialogAction } from '../../common/SoftDeleteWithDialogAction';
import { Batches, Programs } from '../../custom';
import { BATCH_TEMPLATE_TYPE, STATUSES } from '../../common/constants';
import StatusTags from '../../common/StatusTags';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ClearFiltersOnRouteChange from '../../common/ClearFiltersOnRouteChange';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const Actions = (props: FieldProps<Batches>) => {
    const { isDeletable, isWritable, isUpdatable } = useIsPermission('BATCH_TAMPLATE');

    return (
        <div className={'flex gap-2'}>
            <ShowButton />
            {isUpdatable && <EditButton />}
            {isDeletable && <ConfirmDeleteButton />}
        </div>
    );
};

Actions.defaultProps = {
    label: 'Actions',
};

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="title" alwaysOn />
        <SelectInput source="status" label={'Status'} fullWidth choices={STATUSES} alwaysOn />
        <SelectInput
            source="type"
            label={'Type'}
            fullWidth
            choices={BATCH_TEMPLATE_TYPE}
            alwaysOn
        />
    </Filter>
);
const BatchesLinkField = (props: FieldProps<Programs>) => {
    const record = useRecordContext<Programs>();
    if (!record) {
        return null;
    }
    return (
        <Link
            to={`/batches?filter=${encodeURIComponent(JSON.stringify({ template_id: record.id }))}`}
        >
            Batches
        </Link>
    );
};

BatchesLinkField.defaultProps = {
    label: 'Batches',
};

const BatchTemplateList = () => {
    const { isWritable } = useIsPermission('BATCH_TAMPLATE');
    return (
        <List
            filters={<ListFilter />}
            actions={<PermissionBasedActions isWritable={isWritable} />}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <ClearFiltersOnRouteChange />
            <Datagrid bulkActionButtons={false}>
                <TextField source="title" />
                <TextField source="slug" />
                <TextField source="type" />
                <StatusTags source="status" label={'Status'} />
                <BatchesLinkField />
                <FormattedDateTimeField source="createdAt" />
                <Actions />
            </Datagrid>
        </List>
    );
};
export default BatchTemplateList;
